import { GET_MBL_DISTRIBUTOR_ONBOARDING_LIST } from "../../Types";

const MBLDistributorOnboardingListReducer = (state = [], action) => {
  switch (action.type) {
    case GET_MBL_DISTRIBUTOR_ONBOARDING_LIST:
      return action.payload;

    default:
      return state;
  }
};
export default MBLDistributorOnboardingListReducer;
